var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45723 4C4.34049 4 4.22216 4.04535 4.13331 4.13419C3.95589 4.31162 3.95589 4.60459 4.13331 4.78189L7.35142 8L4.13331 11.2181C3.95589 11.3955 3.95589 11.6885 4.13331 11.8658C4.21925 11.9517 4.3393 12 4.45723 12C4.57516 12 4.69507 11.9519 4.78114 11.8658L7.99925 8.64783L11.2174 11.8658C11.3033 11.9517 11.4233 12 11.5413 12C11.6572 12 11.7736 11.9574 11.8652 11.8658C12.0426 11.6884 12.0426 11.3954 11.8652 11.2181L8.64721 8L11.8652 4.78189C12.0426 4.60446 12.0426 4.31149 11.8652 4.13419C11.6878 3.9569 11.3948 3.95677 11.2175 4.13419L7.99938 7.35231L4.78127 4.13419C4.69256 4.04548 4.57423 4 4.45736 4H4.45723Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0e337089552004224f62e78e0eef64d3.svg";
export { ForwardRef as ReactComponent };